import {DateTime} from 'luxon';

export type Occupation = {
    occupationDate: DateTime | null;
    occupationEndDate: DateTime | null;
};

export function isCurrentConsumer(consumer: Occupation, today: DateTime): boolean {
    const started = consumer.occupationDate == null || consumer.occupationDate <= today;
    const notEnded = consumer.occupationEndDate == null || consumer.occupationEndDate >= today;
    return started && notEnded;
}
